import cloneDeep from "lodash/cloneDeep";
import omit from "lodash/omit";
import qs from "qs";

import { convertToSnakeCase, removeEmptyFields } from "utils";

const cleanFields = (params) => removeEmptyFields(cloneDeep(params));

export const urlWithParams = (path, params) =>
  `${path}?${qs.stringify(cleanFields(params), { arrayFormat: "brackets" })}`;

export const apiUrlWithParams = (path, params) =>
  `${path}?${qs.stringify(convertToSnakeCase(cleanFields(params)), {
    arrayFormat: "brackets",
  })}`;

export const assetUrlWithParams = (path, params) =>
  urlWithParams(
    path,
    omit(params, [
      "isFiltering",
      "budgetCurrency",
      !params.sizeMax && !params.sizeMin && "sizeUnit",
      !params.budgetMax && !params.budgetMin && "budgetPeriod",
    ])
  );

export const createUrlParams = (params, format = "brackets") =>
  qs.stringify(params, { arrayFormat: format, addQueryPrefix: true });

export const getUrlParams = () => qs.parse(window.location.search, { ignoreQueryPrefix: true });
